import { SearchBarExpansiveFieldConfigWithHeader } from '@components/SearchBars';
import { useState } from '@hookstate/core';
import { ClickAwayListener } from '@material-ui/core';
import { ICustomField } from '@models/CustomField.model';
import FieldConfiguration, {
  EquipmentFieldConfigurationTypeOptions,
  FieldConfigurationLocationOptions,
  IFieldConfiguration,
} from '@models/FieldConfiguration.model';
import { useState as classicUseState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Container, FlexRowContainer } from './AddField.styles';
import { MaybeUndef } from './AddField.types';
import { findEquipmentField } from './AddField.utils';

interface InfoEditableProps {
  options: string[];
  optionsCustom: string[];
  customFields?: ICustomField[];
  fieldsConfiguration: IFieldConfiguration[];
  updateFieldConfiguration: (list: IFieldConfiguration[]) => void;
  index: number;
  location: FieldConfigurationLocationOptions;
}
const AddField = ({
  options,
  index,
  customFields,
  fieldsConfiguration,
  updateFieldConfiguration,
  optionsCustom,
  location,
}: InfoEditableProps) => {
  const open = useState(false);
  const [showOptions, setShowOptions] = classicUseState<string[]>([]);
  const [showCustomOptions, setShowCustomOptions] = classicUseState<string[]>(
    [],
  );

  const handleClickIn = () => {
    open.set(true);
    setShowOptions(options);
    setShowCustomOptions(optionsCustom);
  };

  const handleClickOut = async () => {
    open.set(false);
    setShowOptions([]);
    setShowCustomOptions([]);
  };

  function handleOnChangeSelect(event: string) {
    const equipmentField = findEquipmentField(
      location,
      event,
    ) as MaybeUndef<EquipmentFieldConfigurationTypeOptions>;
    if (equipmentField) {
      updateFieldConfiguration([
        ...fieldsConfiguration,
        FieldConfiguration.fromApiModel(
          {
            id: uuidv4(),
            order: index,
            location,
            fieldName: equipmentField,
          },
          location,
        ),
      ]);
    } else {
      const customFieldFound = customFields?.find(
        field => field.name === event,
      );
      if (customFieldFound) {
        updateFieldConfiguration([
          ...fieldsConfiguration,
          FieldConfiguration.fromApiModel(
            {
              order: index,
              id: uuidv4(),
              location,
              customField: {
                id: customFieldFound.id,
                name: customFieldFound.name,
                type: customFieldFound.type,
                studioConfigurationId: '',
                isUnique: false,
                isSearchable: false,
                fieldContents: [],
                selectableValues: [],
                defaultValue: customFieldFound.defaultValue,
              },
            },
            location,
          ),
        ]);
      }
    }
    setShowOptions([]);
    setShowCustomOptions([]);
  }

  const handleClickAway = () => {
    handleClickOut();
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <FlexRowContainer>
        <Container isHidden={!open.get()} isNotDate>
          <SearchBarExpansiveFieldConfigWithHeader
            showOptions={showOptions}
            showCustomOptions={showCustomOptions}
            searchText="Add Column"
            handleClickSearch={handleClickIn}
            isHidden={!open.get()}
            onClickFilter={input => handleOnChangeSelect(input)}
          />
        </Container>
      </FlexRowContainer>
    </ClickAwayListener>
  );
};
export { AddField };
